import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { withViewport } from '../../util/contextHelpers';

import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  ExternalLink,
  SectionCustomerLogos,
  SectionHowItWorks,
  SectionLocations,
  FaqDropdown,
  SuccessStoryBanner,
  NamedLink,
  ContactPreFooter,
} from '../../components';
import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';
import { BsFillCheckCircleFill } from 'react-icons/bs';

import { IoIosArrowDown } from 'react-icons/io';

import SolutionPageHeroSection from './SolutionPageHeroSection';

import heroImage from '../../assets/organization-freelancer-hero-image.webp';
import succesStoryBannerImage from '../../assets/misme_halonen-quote.jpeg';
import miikkaImg from '../../assets/pro-miikka-salminen.webp';

import css from './SolutionPages.css';

const OrganizationSolutionPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  const schemaTitle = intl.formatMessage({ id: 'OrganizationSolutionPage.schemaTitle' });
  const schemaDescription = intl.formatMessage({
    id: 'OrganizationSolutionPage.schemaDescription',
  });

  const heroTitle = (
    <FormattedMessage
      id="OrganizationSolutionPage.heroTitle"
      values={{
        b: chunks => <strong style={{ color: '#1683A3', fontWeight: 600 }}>{chunks}</strong>,
      }}
    />
  );
  const heroSubtitle = intl.formatMessage({ id: 'OrganizationSolutionPage.heroSubtitle' });
  const heroButtonText = intl.formatMessage({ id: 'OrganizationSolutionPage.heroButtonText' });

  const handleShowSpaceHome = () => {
    if (typeof window === 'object') {
      window.Intercom('showSpace', 'home');
    }
  };

  const HowItWorksCard = ({ title, description, checkmarkText }) => {
    return (
      <div className={css.howItWorksCard}>
        <div>
          <div className={css.howItWorksCardTitle}>{title}</div>
          <div className={css.howItWorksCardDescription}>{description}</div>
        </div>
        <div className={css.howItWorksCardCheckmarkContainer}>
          <BsFillCheckCircleFill className={css.howItWorksCardCheckmark} />
          {checkmarkText}
        </div>
      </div>
    );
  };

  const sectionHowItWorksHeader = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksHeader" />
  );
  const sectionHowItWorksCardTitle1 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksCardTitle1" />
  );
  const sectionHowItWorksCardTitle2 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksCardTitle2" />
  );
  const sectionHowItWorksCardTitle3 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksCardTitle3" />
  );
  const sectionHowItWorksCardDescription1 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksCardDescription1" />
  );
  const sectionHowItWorksCardDescription2 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksCardDescription2" />
  );
  const sectionHowItWorksCardDescription3 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksCardDescription3" />
  );
  const sectionHowItWorksInfoImageName = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksInfoImageName" />
  );
  const sectionHowItWorksInfoImageText1 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksInfoImageText1" />
  );
  const sectionHowItWorksInfoImageText2 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksInfoImageText2" />
  );
  const sectionHowItWorksInfoImageText3 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksInfoImageText3" />
  );
  const sectionHowItWorksInfoImageText4 = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksInfoImageText4" />
  );
  const sectionHowItWorksCTA = (
    <FormattedMessage id="OrganizationSolutionPage.sectionHowItWorksCTA" />
  );

  const howItWorksCardTitle1 = (
    <FormattedMessage id="OrganizationSolutionPage.howItWorksCardTitle1" />
  );
  const howItWorksCardText1 = (
    <FormattedMessage id="OrganizationSolutionPage.howItWorksCardText1" />
  );
  const howItWorksCardCheckmarkText1 = (
    <FormattedMessage id="OrganizationSolutionPage.howItWorksCardCheckmarkText1" />
  );
  const howItWorksCardTitle2 = (
    <FormattedMessage id="OrganizationSolutionPage.howItWorksCardTitle2" />
  );
  const howItWorksCardText2 = (
    <FormattedMessage id="OrganizationSolutionPage.howItWorksCardText2" />
  );
  const howItWorksCardCheckmarkText2 = (
    <FormattedMessage id="OrganizationSolutionPage.howItWorksCardCheckmarkText2" />
  );
  const howItWorksCardTitle3 = (
    <FormattedMessage id="OrganizationSolutionPage.howItWorksCardTitle3" />
  );
  const howItWorksCardText3 = (
    <FormattedMessage id="OrganizationSolutionPage.howItWorksCardText3" />
  );
  const howItWorksCardCheckmarkText3 = (
    <FormattedMessage id="OrganizationSolutionPage.howItWorksCardCheckmarkText3" />
  );

  const [faqIsShown, setFaqIsShown] = useState([
    {
      question: <FormattedMessage id="OrganizationSolutionPage.sectionFAQQuestion1" />,
      answer: (
        <FormattedMessage
          id="OrganizationSolutionPage.sectionFAQAnswer1"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      index: 0,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: <FormattedMessage id="OrganizationSolutionPage.sectionFAQQuestion2" />,
      answer: (
        <FormattedMessage
          id="OrganizationSolutionPage.sectionFAQAnswer2"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      index: 1,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: <FormattedMessage id="OrganizationSolutionPage.sectionFAQQuestion3" />,
      answer: (
        <FormattedMessage
          id="OrganizationSolutionPage.sectionFAQAnswer3"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      index: 2,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: <FormattedMessage id="OrganizationSolutionPage.sectionFAQQuestion4" />,
      answer: (
        <FormattedMessage
          id="OrganizationSolutionPage.sectionFAQAnswer4"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      index: 3,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: <FormattedMessage id="OrganizationSolutionPage.sectionFAQQuestion5" />,
      answer: (
        <FormattedMessage
          id="OrganizationSolutionPage.sectionFAQAnswer5"
          values={{
            lineBreak: <br />,
          }}
        />
      ),
      index: 4,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
  ]);

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="OrganizationSolutionPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.sections}>
            <SolutionPageHeroSection
              title={heroTitle}
              subTitle={heroSubtitle}
              buttonText={heroButtonText}
              imgSrc={heroImage}
              handleShowSpaceHome={handleShowSpaceHome}
            />
            <SectionCustomerLogos
              toShow={[
                'peikko',
                'olefit',
                'eerikkila',
                'corego',
                'helsinki',
                'invesdor',
                'systam',
                'zervant',
              ]}
            />
            <SectionHowItWorks
              header={sectionHowItWorksHeader}
              cardTitle1={sectionHowItWorksCardTitle1}
              cardTitle2={sectionHowItWorksCardTitle2}
              cardTitle3={sectionHowItWorksCardTitle3}
              cardDescription1={sectionHowItWorksCardDescription1}
              cardDescription2={sectionHowItWorksCardDescription2}
              cardDescription3={sectionHowItWorksCardDescription3}
              infoImageName={sectionHowItWorksInfoImageName}
              infoImageText1={sectionHowItWorksInfoImageText1}
              infoImageText2={sectionHowItWorksInfoImageText2}
              infoImageText3={sectionHowItWorksInfoImageText3}
              infoImageText4={sectionHowItWorksInfoImageText4}
              cta={sectionHowItWorksCTA}
              atLandingPage={true}
            />
            <SuccessStoryBanner
              imgSrc={succesStoryBannerImage}
              textId={'OrganizationSolutionPage.successStoryBannerText'}
              fromId={'OrganizationSolutionPage.successStoryBannerFrom'}
              companyId={'OrganizationSolutionPage.successStoryBannerCompany'}
              pageName={'SuccessStoryHartwallPage'}
              buttonTxtId={'OrganizationSolutionPage.successStoryBannerCTAtext'}
            />
            <SectionLocations titleId={'OrganizationSolutionPage.locationsTitle'} />
            <div className={css.sectionFAQContent}>
              <div className={css.sectionFAQTitle}>
                <FormattedMessage id="OrganizationSolutionPage.sectionFAQTitle" />
              </div>
              <FaqDropdown faqIsShown={faqIsShown} setFaqIsShown={setFaqIsShown} />
            </div>
            <div className={css.sectionHowItWorksContent}>
              <div className={css.howItWorksTitle}>
                <FormattedMessage id="StartSellingInfoPage.howItWorksTitle" />
              </div>
              <div className={css.howItWorksCardContainer}>
                <HowItWorksCard
                  title={howItWorksCardTitle1}
                  description={howItWorksCardText1}
                  checkmarkText={howItWorksCardCheckmarkText1}
                />
                <HowItWorksCard
                  title={howItWorksCardTitle2}
                  description={howItWorksCardText2}
                  checkmarkText={howItWorksCardCheckmarkText2}
                />
                <HowItWorksCard
                  title={howItWorksCardTitle3}
                  description={howItWorksCardText3}
                  checkmarkText={howItWorksCardCheckmarkText3}
                />
              </div>
              <div className={css.howItWorksCTA}>
                <NamedLink className={css.howItWorksCTAButton} name="SignupPage">
                  <FormattedMessage id="OrganizationSolutionPage.howItWorksCTA" />
                </NamedLink>
              </div>
            </div>
          </div>
          <ContactPreFooter />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { number, shape } = PropTypes;

OrganizationSolutionPageComponent.propTypes = {
  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired, // from injectIntl
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

const OrganizationSolutionPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(OrganizationSolutionPageComponent);

export default OrganizationSolutionPage;
